export default "__VITE_ASSET__14641cf4__"